import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext';
import DiscoverPsyPage from './DiscoverPageV2';

export default WithGASetup(DiscoverPsyPage, AuthContext);
